import moment from 'moment';
import {
  getPriceRevealV2WebFeatureFlag,
  getPriceRevealWebData,
  getPriceRevealLUXEFlag,
  getPriceRevealMobileData,
  getPriceRevealV2MobileFeatureFlag,
  getEarlyAccessData,
  getEarlyAccessFlag
} from '../../../Flags/selectors';
import { DURING_SALE, PRE_BUZZ } from './messages';
import { isPhoneUserAgent } from '../../../utils/loginUtil';

export const getEarlyAccessDetails = flags =>
  getEarlyAccessFlag(flags) ? getEarlyAccessData(flags) : false;
export const getMobileFeatureFlag = flags =>
  getPriceRevealV2MobileFeatureFlag(flags) ? getPriceRevealMobileData(flags) : false;
export const getWebFeatureFlag = flags =>
  getPriceRevealV2WebFeatureFlag(flags) ? getPriceRevealWebData(flags) : false;

export const getDeviceBasedFlag = (deviceType, flags) => {
  if (deviceType === 'desktop') {
    return getWebFeatureFlag(flags);
  }
  return getMobileFeatureFlag(flags);
};

export const getPageTypesBasedFlag = (deviceType, flags, store = 'AJIO') => {
  try {
    if (store === 'luxe') {
      if (!getPriceRevealLUXEFlag(flags)) return false;
    }

    const flagConfig = getDeviceBasedFlag(deviceType, flags);

    let isGpay = false;
    let isPhonepe = false;
    let pathname = '';

    // Only execute these lines on client side
    if (typeof window !== 'undefined' && typeof sessionStorage !== 'undefined') {
      isGpay = sessionStorage.getItem('gpay') === 'true';
      isPhonepe =
        sessionStorage.getItem('phonepe') === 'true' || isPhoneUserAgent();
      pathname = window.location?.pathname || '';
    }

    const isMicroApp = isGpay || isPhonepe;

    let pageType = 'PLP';
    if (pathname.includes('/wishlist')) {
      pageType = 'WISHLIST';
    }
    if (pathname.includes('/p/')) {
      pageType = 'PDP';
    }

    if (!flagConfig || isMicroApp) return false;

    switch (pageType) {
      case 'PLP':
        return flagConfig.priceRevealPLPFlag === 'ON';
      case 'PDP':
        return flagConfig.priceRevealPDPFlag === 'ON';
      case 'WISHLIST':
        return flagConfig.priceRevealWISHLISTFlag === 'ON';
      default:
        return false;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
};


export const getPriceRevealSaleDuration = (flags, deviceType, priceRevealMetaInfo, store) => {
  let { saleStartTime, saleEndTime } = priceRevealMetaInfo || {};
  const currentTS = parseInt(Date.now() / 1000, 10);
  saleStartTime = typeof saleStartTime === 'string' ? parseInt(saleStartTime, 10) : saleStartTime;
  saleEndTime = typeof saleEndTime === 'string' ? parseInt(saleEndTime, 10) : saleEndTime;
  if (!saleStartTime || !saleEndTime || !getPageTypesBasedFlag(deviceType, flags, store)) {
    return null;
  }
  if (currentTS >= saleStartTime && currentTS < saleEndTime) {
    return DURING_SALE;
  }
  if (currentTS < saleStartTime) {
    return PRE_BUZZ;
  }
  return null;
};

export const getSaleStartEndText = (priceRevealMetaInfo, saleState, flags, deviceType, store) => {
  let { saleStartTime, saleEndTime } = priceRevealMetaInfo || {};

  if (store === 'luxe') {
    const currentTS = parseInt(Date.now() / 1000, 10);
    saleStartTime = typeof saleStartTime === 'string' ? parseInt(saleStartTime, 10) : saleStartTime;
    saleEndTime = typeof saleEndTime === 'string' ? parseInt(saleEndTime, 10) : saleEndTime;
  }

  const { bbsSaleEndText, bbsSaleStartText, luxeSaleLiveText } =
    deviceType === 'msite' ? getPriceRevealMobileData(flags) : getPriceRevealWebData(flags);
  if (store === 'luxe') {
    return saleState === 'PRE_BUZZ'
      ? `Sale starts on ${moment(saleStartTime, 'X').format('MMMM D, h:mm a')}`
      : luxeSaleLiveText;
  }
  return saleState === 'PRE_BUZZ' ? bbsSaleStartText : bbsSaleEndText;
};

export const getEalyAccessText = priceRevealMetaInfo => {
  let { saleStartTime, saleEndTime } = priceRevealMetaInfo || {};
  if (!saleEndTime) return null;
  return moment(saleEndTime, 'X').format('h:mm a');
};

export const getBBSWidgetTitleForGA = (
  priceRevealState,
  flags,
  deviceType,
  store,
  priceRevealMetaInfo
) => {
  let title;
  if (getEarlyAccessFlag(flags) && priceRevealState !== DURING_SALE && store !== 'luxe') {
    let earlyAccessData = getEarlyAccessData(flags);
    title = earlyAccessData?.earlyAccessText;
  } else {
    let widgetTitle = getSaleStartEndText(
      priceRevealMetaInfo,
      priceRevealState,
      flags,
      deviceType,
      store
    );
    title = widgetTitle;
  }
  return title;
};
